import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginHorizontal: 20,
        marginVertical: 10
    },
    logoNameContainer: {
        marginLeft: 14,
        flexDirection: 'row',
        flexGrow: 1
    },
    itemName: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.primaryFontSize,
        color: Theme.secondaryButtonBorderColor,
        textAlign: 'left',
        marginLeft: 20
    }
};

export default StyleSheet.create(baseStyles);
